module.exports = __webpack_public_path__ + "media/images/landing/home/categories/schools-47eb3b7a3747cdb4bb3284890d22861a.png";